var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.25,
    height: 85.25,
    viewBox: "0 0 85.25 85.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "M44.23,39.608l-10.8-10.8,10.8-10.8A3.275,3.275,0,1,0,39.6,13.378l-10.8,10.8L18,13.378a3.133,3.133,0,0,0-4.631,0,3.164,3.164,0,0,0,0,4.631l10.8,10.8-10.8,10.8a3.166,3.166,0,0,0,0,4.631,3.253,3.253,0,0,0,4.631,0l10.8-10.8,10.8,10.8a3.29,3.29,0,0,0,4.631,0A3.253,3.253,0,0,0,44.23,39.608Z",
    transform: "translate(17.201 17.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "M46,9.113A36.893,36.893,0,0,1,72.087,72.087,36.893,36.893,0,0,1,19.913,19.913,36.643,36.643,0,0,1,46,9.113m0-5.738A42.625,42.625,0,1,0,88.625,46,42.619,42.619,0,0,0,46,3.375Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleOutline);
export default __webpack_public_path__ + "static/media/close_circle_outline.0950a7b08144cf55e2f5008d359a2f77.svg";
export { ForwardRef as ReactComponent };